import React, { useEffect, useContext } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { UserContext } from './UserContext';
import axiosInstance from './axiosInstance';
import moment from 'moment-timezone';

const API_URL = process.env.REACT_APP_API_URL;

export default function Enter() {
  const { email: paramEmail, link: paramToken } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { email, setUser, setEmail } = useContext(UserContext);
  
  const newYorkTime = moment().tz("America/New_York").format('YYYY-MM-DD HH:mm:ss Z');
  
  const getIsStudent = () => {
    // Safely get and parse the value
    const storedValue = sessionStorage.getItem('isStudent');
    return storedValue === 'true'; // Explicit boolean conversion
  };

  const signIn = async (email, magicLink) => {
    // Get and parse isStudent from sessionStorage
    const isStudent = sessionStorage.getItem('isStudent') === 'true';
    console.log('Auth flow - isStudent:', isStudent, 'Type:', typeof isStudent);
  
    try {
      const res = await axiosInstance.post(
        `${API_URL}/users/enter`,
        { email, magicLink },
        { withCredentials: true }
      );
  
      if (!res?.data?.success) {
        console.error('Authentication failed:', res?.data?.message || 'Unknown error');
        return null;
      }
  
      localStorage.setItem('token', res.data.token);
      const backendRole = res.data.role;
  
      // Role determination logic
      let finalRole;
      if (backendRole === 'admin') {
        finalRole = 'admin';
      } else if (backendRole === 'creative') {
        finalRole = 'creative'; // Explicitly preserve creative role
      } else {
        finalRole = isStudent ? 'student' : 'user';
      }
  
      // Create user object will all available data
      const user = { 
        email, 
        role: finalRole,
        // Include any other relevant user data from res.data
        ...(res.data.name && { name: res.data.name }),
        ...(res.data.picture && { picture: res.data.picture }),
        ...(res.data.id && { id: res.data.id })
      };
  
    
  
      // Update all user states
      setUser(user);
      
      sessionStorage.setItem('userEmail', email);
      sessionStorage.setItem('userRole', finalRole);
      localStorage.setItem('userEmail', email); 

      if (res.data.name) sessionStorage.setItem('userName', res.data.name);
      if (res.data.picture) sessionStorage.setItem('userPicture', res.data.picture);  

      return user;
    } catch (error) {
      console.error('Error during sign-in:', error);
   
      return null;
    }
  };
 

  useEffect(() => {
    let isMounted = true;

    const handleGoogleOAuth = async () => {
      const params = new URLSearchParams(location.search);
      const code = params.get('code');
      const role = params.get('state') || sessionStorage.getItem('accountType') || 'user';

      if (!code) return false; // No Google code? Skip this. 
      try {
        // Exchange Google code for token
        const response = await axiosInstance.post(
          `${process.env.REACT_APP_API_URL}/users/auth/google`,
          { code, role }
        );
        const { token, email, name, picture } = response.data;
        setEmail(email);
        if (name) sessionStorage.setItem('userName', name);
        if (picture) sessionStorage.setItem('userPicture', picture);
        
        // Ensure URL structure mirrors magic link flow
        window.location.href = `${window.location.origin}/enter/${email}/${token}`;
        return true; // Google OAuth handled
      } catch (error) {
        // Blocked user case
        if (error.response?.status === 403 && error.response.data?.status === 'blocked') {
          navigate('/');
          return true; // Explicitly handled
        }
        navigate('/login-signup?error=oauth_failed');
      }
      return false;
    };

    // In Enter.jsx
const handleMagicLink = async () => {
  if (!paramToken) {
    navigate('/login-signup');
    return;
  }

  try {
    const user = await signIn(paramEmail, paramToken);
    
    if (!user) {
      throw new Error('Sign-in returned null');
    }

    // Store user data
    sessionStorage.setItem('userEmail', paramEmail);
    localStorage.setItem('userEmail', paramEmail);
    sessionStorage.setItem('token', paramToken);

    // Update last login for all roles
    await axiosInstance.post(
      `${process.env.REACT_APP_API_URL}/users/update-last-login`,
      { email: paramEmail, newYorkTime }
    );

    // Navigate based on role
    let targetRoute;
    switch(user.role) {
      case 'student':
        targetRoute = '/sat-dashboard';
        break;
      case 'creative':
        targetRoute = '/creator-dashboard';
        break;
      case 'admin':
        targetRoute = '/admin';
        break;
      default: // 'user' and any other cases
        targetRoute = '/dashboard';
    }
    
    console.log(`Navigating to ${targetRoute} for role ${user.role}`);
    navigate(targetRoute, { replace: true });

    } catch (error) {
      console.error('Magic link validation failed:', error);
      sessionStorage.removeItem('isStudent');
      navigate('/login-signup', { state: { error: 'login_failed' } });
    }
  };
    
    const verifyAuth = async () => {
      if (!isMounted) return;

      // Handle Google OAuth first. Redirect if successful.
      const googleHandled = await handleGoogleOAuth();

      // If Google wasn't handled, attempt magic link flow.
      if (!googleHandled) {
        await handleMagicLink();
      }
    };

    verifyAuth();

    return () => {
      isMounted = false; // Cleanup on unmount
    };
  }, [navigate, location.search, paramEmail, paramToken, newYorkTime]);

  return (
    <div>
      <p>Verifying your credentials...</p>
    </div>
  );
}
